
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 101,
  height: 100,
  viewBox: "0 0 101 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 5h90v90h-90z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.86 22.456a25.243 25.243 0 0 1 37.884 21.919c0 12.591 2.634 19.898 4.954 23.892A2.812 2.812 0 0 1 78.28 72.5H22.721a2.812 2.812 0 0 1-2.42-4.234c2.322-3.994 4.958-11.3 4.958-23.891a25.243 25.243 0 0 1 12.6-21.92zM39.25 72.5v2.813c0 6.213 5.037 11.25 11.25 11.25s11.25-5.037 11.25-11.25V72.5",
  stroke: "#000",
  strokeWidth: 3.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.988 13.433a36.726 36.726 0 0 1 13.33 14.807m-65.637 0a36.726 36.726 0 0 1 13.331-14.807",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width='101' height='100' viewBox='0 0 101 100' xmlns='http://www.w3.org/2000/svg'>\r\n  <g fill='none' fill-rule='evenodd'>\r\n    <path d='M5.5 5h90v90h-90z' />\r\n    <path\r\n      d='M37.86 22.456a25.243 25.243 0 0 1 37.884 21.919c0 12.591 2.634 19.898 4.954 23.892A2.812 2.812 0 0 1 78.28 72.5H22.721a2.812 2.812 0 0 1-2.42-4.234c2.322-3.994 4.958-11.3 4.958-23.891a25.243 25.243 0 0 1 12.6-21.92zM39.25 72.5v2.813c0 6.213 5.037 11.25 11.25 11.25s11.25-5.037 11.25-11.25V72.5'\r\n      stroke='#000'\r\n      stroke-width='3.75'\r\n      stroke-linecap='round'\r\n      stroke-linejoin='round'\r\n    />\r\n    <path\r\n      d='M69.988 13.433a36.726 36.726 0 0 1 13.33 14.807m-65.637 0a36.726 36.726 0 0 1 13.331-14.807'\r\n      stroke=\"var(--theme-primary, #810ea9)\"\r\n      stroke-width='3.75'\r\n      stroke-linecap='round'\r\n      stroke-linejoin='round'\r\n    />\r\n  </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bell.f3753afff807acfed0c854f4ca887244.svg"),
        {
          React: SvgBell,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      